export default __webpack_public_path__ + "static/media/back.6f17c3ca.jpg";